export interface BatchProgress {
  completed: number;
  total: number;
  percentage: number;
}

export class AsyncBatcher<T> {
  private operations: (() => Promise<T>)[];
  private batchSize: number;
  private onProgress?: (progress: BatchProgress) => void;

  constructor(
    operations: (() => Promise<T>)[],
    batchSize: number = 5,
    onProgress?: (progress: BatchProgress) => void
  ) {
    this.operations = operations;
    this.batchSize = batchSize;
    this.onProgress = onProgress;
  }

  async execute(): Promise<T[]> {
    const results: T[] = [];
    let completed = 0;
    const total = this.operations.length;

    // Process operations in batches
    for (let i = 0; i < this.operations.length; i += this.batchSize) {
      const batch = this.operations.slice(i, i + this.batchSize);

      // Execute current batch concurrently
      const batchResults = await Promise.all(batch.map((op) => op()));
      results.push(...batchResults);

      // Update progress
      completed += batch.length;
      const percentage = Math.round((completed / total) * 100);

      if (this.onProgress) {
        this.onProgress({ completed, total, percentage });
      }
    }

    return results;
  }
}
